import { supabase } from "@/integrations/supabase/client";

export const SMS_SIGN_IN_FLAG = "sms_sign_in";

/** Missing, loading, or false all stay off. Only an explicit true enables SMS sign-in. */
export function smsSignInAllowed(defaultEnabled: boolean | null | undefined): boolean {
  return defaultEnabled === true;
}

export async function readSmsSignInEnabled(): Promise<boolean> {
  const { data, error } = await supabase
    .from("feature_flags")
    .select("default_enabled")
    .eq("key", SMS_SIGN_IN_FLAG)
    .maybeSingle();
  if (error || !data) return false;
  return smsSignInAllowed(data.default_enabled);
}

export async function sendPhoneSignInCode(phone: string) {
  if (!(await readSmsSignInEnabled())) {
    return { error: { message: "SMS sign-in is turned off" } };
  }
  return supabase.auth.signInWithOtp({ phone });
}

export async function verifyPhoneSignInCode(phone: string, token: string) {
  if (!(await readSmsSignInEnabled())) {
    return { error: { message: "SMS sign-in is turned off" } };
  }
  return supabase.auth.verifyOtp({ phone, token, type: "sms" });
}
